module.exports = __webpack_public_path__ + "img/西瓜3.685e881a.png";